import { GET, POST, PUT } from './Clients';

const FRONTEND_APIS_PREFIX = '/marketplace/frontend-apis/v2';

export async function initCustomerCatalog() {
  return POST({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/init` });
}

export async function getCustomerCatalogInitState() {
  return GET({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/init-state` });
}

export async function getCustomerCatalog({ search = '', chip = '', category = '', sort = '', offset = 0, limit = 0 } = {}) {
  return GET({
    url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog`,
    params: { search, chip, category, sort, offset, limit },
  });
}

export async function getCustomerCatalogLots(productId) {
  return GET({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/lots`, params: { productId } });
}

export async function searchCustomerCatalogProduct({ text, limit = 20 }) {
  return POST({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/search`, body: { text, limit } });
}

export async function addCustomerCatalogItems(productIds) {
  return POST({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/add`, body: { productIds } });
}

export async function removeCustomerCatalogItems(productIds) {
  return PUT({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/remove`, body: { productIds } });
}

export async function pinCustomerCatalogItem({ productId, isPinned }) {
  return PUT({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/pin`, body: { productId, isPinned } });
}

// "Tên thuốc hay dùng" khách tự đặt cho product; alias rỗng = xoá tên
export async function updateCustomerCatalogAlias({ productId, alias }) {
  return PUT({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/alias`, body: { productId, alias } });
}

export async function arrangeCustomerCatalog(productIds) {
  return PUT({ url: `${FRONTEND_APIS_PREFIX}/screen/customer-catalog/arrange`, body: { productIds } });
}
